import { environment } from '../../../../environments/environment';

export const BASE_ONBOARDING_URL = `${environment.muleExperienceBaseURI}${environment.muleExperienceOnboardingApi}`;

export const PARTY_SERVICE_API_ROUTES = {
	postParty: () => `${BASE_ONBOARDING_URL}/party`,
	otp: (partyId: string) => `${BASE_ONBOARDING_URL}/party/${partyId}/otp`,
	patchParty: (partyId: string) => `${BASE_ONBOARDING_URL}/party/${partyId}`,
	getParty: (partyId: string) => `${BASE_ONBOARDING_URL}/party/${partyId}`,
	migrateT24Profile: () =>
		`${environment.muleExperienceBaseURI}/party/migrate-t24-profile`
};
